import { IStore, IAction } from "store";
import { DealAction } from "../../actions";
import { IHandleItem, IEmail } from "../../types";
import { reducer } from "../index";
import { itemObjectHandlers } from "utils/item-object-handlers";

reducer.createHandler(
  DealAction.HandleEmailSuccess,
  (state: IStore, { payload }: IAction<IHandleItem<IEmail>>): IStore => {
    const { item: email, event } = payload;
    if (email.deal_id === state.dealModule.deal.id) {
      return {
        ...state,
        dealModule: {
          ...state.dealModule,
          emails: itemObjectHandlers[event](email, state.dealModule.emails || [])
        }
      };
    } else {
      return state;
    }
  }
);

reducer.createHandler(
  DealAction.GetEmailMetaSuccess,
  (state: IStore, { payload: emailMeta }: IAction<IEmail>): IStore => ({
    ...state,
    dealModule: {
      ...state.dealModule,
      emailMeta
    }
  })
);

reducer.createHandler(
  DealAction.InvalidateEmailMeta,
  (state: IStore): IStore => ({
    ...state,
    dealModule: {
      ...state.dealModule,
      emailMeta: null
    }
  })
);

reducer.createHandler(DealAction.GetEmailsSuccess, (state, { payload }: IAction<Record<number, IEmail>>) => ({
  ...state,
  dealModule: {
    ...state.dealModule,
    emails: payload
  }
}));
